export default {
    view: "Register"
};